import { StateServices } from './../../../../services/state.services'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { BehaviourSettingServices } from '../../../../services/BehaviourSetting.services'
import { SharedServices } from '../../../../services/shared.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { Direction } from "../../../../../models/image.style"
import { notification } from 'onsenui'
@Component({
    selector: 'app-behaviour',
    templateUrl: './behaviour.component.html',
    styleUrls: [
        './behaviour.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../common/common.component.css',
    ],
})
export class BehaviourComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN: Boolean = true
    jsonAllOptionSetting: any = {}
    optionSetting: any = 'noteTag'
    formSetting: any = 'aligner'
    arrTimeline: any[] = []
    arrRoom: any[] = []
    arrMessage: any[] = []
    resourceUrl: any = 'resource'

    jsonAllFormSetting: any = {
        alignerStatus: [],
        clientAlignerForm: {
            properties: [],
            type: 'object',
        },
        clientProfileForm: {
            properties: [],
            type: 'object',
        },
        clientProfileFormFooter: {
            properties: [],
            type: 'object',
        },
        clientProfileFormHeader: {
            properties: [],
            type: 'object',
        },
        noteTag: [],
        roomMessageTag: [],
        roomTag: [],
        timelineForms: [],
        _id: 'option',
    }

    behaviourData: any = {
        noteTag: '',
        roomTag: '',
        roomMessageTag: '',
        clientAlignerForm: {},
        clientProfileFormHeader: {},
        clientProfileFormFooter: {},
        timelineForms: [],
    }
    listToothSetting = [
        {title: 'Right', key: 'right'},
        {title: 'Front', key: 'front'},
        {title: 'Left', key: 'left'},
        {title: 'Upper', key: 'upper'},
        {title: 'Overjet', key: 'overjet'},
        {title: 'Lower', key: 'lower'},
    ]
    changeEmittedOptionSetting: any
    dataSaveSetting: any
    saveBehaviorData: any = {}
    enableBehavior: any = 'false'
    toothData:any =  {
      right: Direction.DEFAULT,
      front: Direction.DEFAULT,
      left: Direction.DEFAULT,
      upper: Direction.DEFAULT,
      overjet: Direction.DEFAULT,
      lower: Direction.DEFAULT,
    }
    isHadToothDataSetting: boolean = false

    constructor(private authData: AuthService,
                private _sharedService: SharedServices,
                private restApi: RestServices,
                private behaviourSettingServices: BehaviourSettingServices,
                private router: Router,
                private stateServices: StateServices) {
        this.getCommon()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    ngOnInit() {
        this.getBehaviour()
        const emitJsonAll: any = {}
        emitJsonAll['json'] = this.jsonAllFormSetting
        this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        // this.enableBehavior = true;
        // this.resetDataAllSetting();
        this.getArrAppear()
        this.callApiSetting()
        this.getArrFormSetting()
        this.saveDataBehavior()
    }

    saveDataBehavior() {
        this._sharedService.changeEmittedSource$.subscribe(success => {
            if (success === 'saveOption') {
                this.saveOption()
                this.submitFormToothSetting()
            }
        })
    }

    saveOption() {
        const actions = {
            collection: 'setting',
            id: 'option',
            type: 'update',
        }
        actions['value'] = this.saveBehaviorData
        const resourceData = {
            actions: [actions],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.saveBehaviorData = {}
                this._sharedService.emitChange('savebehaviorSetting')
            })
        })
    }

    // resetDataAllSetting() {
    //     this.behaviourSettingServices.resetDataAllBehaviour$.subscribe(res => {
    //         if (res && res['is_save']) {
    //             this.callApiSetting();
    //         }
    //     });
    // }

    callApiSetting() {
        const resourceDataAccessLog = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                        alignerMail: true,
                        movieMail: true,
                        option: true,
                        testMail: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {     
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const emitJsonAll: any = {}
                    if (success['response']['setting']['map']['option']) {
                        if (this.enableBehavior == 'true') {
                            emitJsonAll['json'] = success['response']['setting']['map']['option']
                        } else {
                            emitJsonAll['json'] = this.jsonAllFormSetting
                        }
                    } else {
                        emitJsonAll['json'] = this.jsonAllFormSetting
                    }
                    if (this.enableBehavior == 'true') {
                        this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)
                    }

                    // Get & Set data for tooth image setting
                    const arraySettingAll: any[] = success['response']['setting']['paths']['{}'];
                    if(arraySettingAll && arraySettingAll.length > 0) {
                        const settingToothImageData = arraySettingAll.find(el => {
                            return el['_id'] == 'settingImage';
                        });
                        if(settingToothImageData && !this.isEmpty(settingToothImageData)) {
                            this.toothData = settingToothImageData
                        }
                    }
                    this.isHadToothDataSetting = true
                },
            )
        })
    }

    ngOnDestroy(): void {
        if(this.changeEmittedOptionSetting)
            this.changeEmittedOptionSetting.unsubscribe()
        this.behaviourSettingServices.emitChangeView(null)
        this.saveBehaviorData = {}
        this.behaviourData = {
            noteTag: '',
            roomTag: '',
            roomMessageTag: '',
            clientAlignerForm: {},
            clientProfileFormHeader: {},
            clientProfileFormFooter: {},
            timelineForms: [],
        }
        this.behaviourSettingServices.emitChangeSaveSetting(null)
        if(this.dataSaveSetting)
            this.dataSaveSetting.unsubscribe()
        this.isHadToothDataSetting = false
    }

    getBehaviour() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        alignerMail: true, common: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const user = success['user']
                this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                const emitSakura = {}
                emitSakura['enableBehavior'] = this.enableBehavior
                this.stateServices.emitChangeEnableBehavior(emitSakura)
                if (this.enableBehavior == 'true') {
                    const tmpBehaviorData = jQuery.extend(true, {}, this.jsonAllFormSetting)
                    this.behaviourData = success['response']['setting']['map']['option'] ? success['response']['setting']['map']['option'] : tmpBehaviorData
                } else {
                    this.behaviourData = jQuery.extend(true, {}, this.jsonAllFormSetting)
                }
            })
        })
    }

    getArrAppear() {
        this.changeEmittedOptionSetting = this.behaviourSettingServices.changeEmittedOptionSetting$.subscribe(data => {
            if (data) {
                this.optionSetting = data['optionSetting']
                if (data['action'] == 'saveClose') {
                    this.dirtyForm()
                }
                this.saveBehaviorData[this.optionSetting] = data.data[this.optionSetting]
                this.behaviourData[this.optionSetting] = data.data[this.optionSetting]
            }
        })
    }

    getArrFormSetting() {
        this.dataSaveSetting = this.behaviourSettingServices.dataSaveSetting$.subscribe(data => {
            if (data && data['tabName']) {
                if (data['tabName'] != 'timelineForms') {
                    const json = {}
                    json['properties'] = data['data']
                    json['type'] = 'object'
                    this.saveBehaviorData[data['tabName']] = json
                } else {
                    this.saveBehaviorData[data['tabName']] = data['data']
                }
            }
        })
    }

    dirtyForm() {
        this._sharedService.emitChange('activeAlertSaveOption')
    }


    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    onShowOptionSetting(option) {
        const emitView: any = {}
        emitView['view'] = 'option-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
        this.optionSetting = option
        const optionSetting: any = {}
        optionSetting['optionSetting'] = this.optionSetting
        optionSetting['action'] = 'active'
        let data = {}
        if (this.enableBehavior == 'true') {
            data = {
                noteTag: this.behaviourData ? this.behaviourData['noteTag'] : [],
                chatTag: this.behaviourData ? this.behaviourData['chatTag'] : [],
                chatPrivateTag: this.behaviourData ? this.behaviourData['chatPrivateTag'] : [],
                roomTag: this.behaviourData ? this.behaviourData['roomTag'] : [],
                roomMessageTag: this.behaviourData ? this.behaviourData['roomMessageTag'] : [],
            }
        } else {
            data = {
                noteTag: [],
                roomTag: [],
                roomMessageTag: [],
                chatTag: [],
                chatPrivateTag: [],
            }
        }
        optionSetting['data'] = data
        this.behaviourSettingServices.emitChangeOptionSetting(optionSetting)
    }

    onShowFormSetting(option) {
        this.formSetting = option
        const emitOptionShow: any = {}
        emitOptionShow['statusFormSetting'] = 'active'
        this.behaviourSettingServices.emitChangeStatusFormSetting(emitOptionShow)
        const optionSetting: any = {}
        optionSetting['formSetting'] = this.formSetting
        this.behaviourSettingServices.emitChangeFormSetting(optionSetting)
        const emitView: any = {}
        emitView['view'] = 'form-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
    }

    renderButtonStatus(name: string, value: number) {
       const isChecked =  this.toothData[name] == value ? 'tag-button-disabled' : '';
       const defaultClass = 'tag-button tag-button-shaded ng-binding ';
       return defaultClass + isChecked;
    }
    
    handleChangeToothDirection(name: string, value: number) {
        if(!this.isHadToothDataSetting) return;
        this.toothData[name] = value
        this.dirtyForm()
    }
    
    showPopupConfirm() {
        if(!this.isHadToothDataSetting) return
            notification.confirm({
                message: this.en['alert-content'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if(i && i !== 0) {
                        this.behaviourSettingServices.emitChangeJsonBehaviorSetting(null)
                        this.behaviourSettingServices.emitChangeOptionSetting(null)
                        if(i === 1) { // When user click Discard button call api reset data to default 
                            this.callApiSetting()
                            this.getBehaviour()
                            this._sharedService.emitChange('statusDiscard')
                        }
                        if(i === 2) { // When user click Save button 
                            this.submitFormToothSetting()
                            this.saveOption()
                            this._sharedService.emitChange(null)
                        }
                    }
                },
            })
    }

    submitFormToothSetting() { // Save setting tooth image direction  data 
        const valueCommon = {...this.toothData}
        const resourceData = {
            actions: [{
                type: 'update', collection: 'setting', id: 'settingImage', value: valueCommon,
            }],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
            })
        })
    }

    isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/behaviour/behaviour.component.ts